__turbopack_context__.v({
  "inline_cta": "InlineCTA-module-scss-module__8DZu0G__inline_cta",
});
